import { Component } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false // NOSONAR
})
export class AppComponent {
  title = 'Allo';  
  template: string =`<img src="assets/loading-icon.gif" alt="">`;
  constructor(private readonly spinner: NgxSpinnerService) {}
  ngOnInit() { // NOSONAR
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 2000);
  }
}
